import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { reduxForm, Field, FieldArray } from 'redux-form';
import _ from 'lodash';
import ReactTable from 'react-table';
import { connect } from 'react-redux';

import { InputField } from 'Common/SemanticWrapper';
import { RECIPE_GROUPS_FORM_NAME } from 'Common/FormEnum';
import {
  ControlInfoRecipeGroupsFormEnum as Fields,
  RecipeGroupFieldEnum,
} from 'Common/FieldEnum';
import {
  ReactTableWrapperColumnProperties,
  ReactTableWrapperCogColumnProperties,
} from 'Common/Constants';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { createToast, toastType } from 'Common/ToastHelper';

import * as RecipeGroupActions from '../state/recipeGroup/actions';

class RecipeGroupTable extends React.Component {
  static propTypes = {
    isReadOnly: PropTypes.bool.isRequired,
  };
  menuOptions = [
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: row => {
        const { dispatch, fields } = this.props;
        dispatch(
          setNotificationDialog({
            ...NOTIFICATION_DIALOG_MESSAGES.REMOVE_RECIPE_GROUP,
            functionsToRunOnOk: [
              async () => {
                const path = _.toPath(row);
                const index = Number(path[1]);

                const field = fields.get(index);

                if (field && field.Id) {
                  const updatedFields = fields
                    .getAll()
                    .filter((x, i) => index !== i);

                  dispatch(
                    RecipeGroupActions.deleteRecipeGroups(updatedFields)
                  );
                } else {
                  fields.remove(index);
                  createToast(
                    toastType.success,
                    'Success',
                    'Deleted Recipe Group',
                    true
                  );
                }
              },
            ],
          })
        );
      },
      disabledWhen: row => {
        return this.props.isReadOnly;
      },
    },
  ];
  render() {
    const { fields } = this.props;
    return (
      <React.Fragment>
        <ReactTable
          data={fields}
          pageSize={fields.length}
          showPageSizeOptions={false}
          showPagination={false}
          minRows={3}
          columns={[
            {
              id: 'Description',
              Header: 'Group Name',
              Cell: row => {
                const name = `${row.original}.${
                  RecipeGroupFieldEnum.Description
                }`;
                return (
                  <Field
                    name={name}
                    maxLength={20}
                    component={InputField}
                    fluid={true}
                    showOnlyTouchedError={true}
                    hideEmptyError={true}
                  />
                );
              },
              ...ReactTableWrapperColumnProperties,
              sortable: false,
              filterable: false,
            },
            {
              ...ReactTableWrapperCogColumnProperties,
              Cell: gridProps => {
                return GridContextMenu({
                  gridProps,
                  options: this.menuOptions,
                });
              },
            },
          ]}
        />
        <Button onClick={() => fields.push({})}>Add New</Button>
      </React.Fragment>
    );
  }
}

RecipeGroupTable = connect()(RecipeGroupTable);

class RecipeGroupsForm extends React.Component {
  static propTypes = {
    isReadOnly: PropTypes.bool.isRequired,
  };
  render() {
    const { isReadOnly } = this.props;
    return (
      <FieldArray
        name={Fields.RecipeGroups}
        component={RecipeGroupTable}
        isReadOnly={isReadOnly}
      />
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  const recipeGroups = values[Fields.RecipeGroups];

  const recipeGroupErrors = [];

  if (Array.isArray(recipeGroups)) {
    recipeGroups.forEach((recipeGroup, index) => {
      const recipeGroupError = {};
      const description = _.trim(
        _.toUpper(_.get(recipeGroup, RecipeGroupFieldEnum.Description))
      );
      if (!description) {
        recipeGroupError[RecipeGroupFieldEnum.Description] =
          'Description is required.';
      } else {
        const { true: numInstances } = _.countBy(recipeGroups, x => {
          return _.trim(_.toUpper(x.Description)) === description;
        });

        if (numInstances > 1) {
          recipeGroupError[RecipeGroupFieldEnum.Description] =
            'Description must be unique.';
        }
      }
      recipeGroupErrors[index] = recipeGroupError;
    });
  }

  errors[Fields.RecipeGroups] = recipeGroupErrors;
  return errors;
};

RecipeGroupsForm = reduxForm({
  form: RECIPE_GROUPS_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(RecipeGroupsForm);

export { RecipeGroupsForm };



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/RecipeGroupsForm.js